import React from 'react'
import { ChromeInstallButton } from './chrome'
import { FirefoxInstallButton } from './firefox'
import { SafariInstallButton } from './safari'
import { extensionInstallTypes, InstallType, useFirstEligibleInstall } from '../../../../lib/hooks/install-eligibility'
import { ExtensionInstallButtonProps } from './base'
import { EdgeChromiumInstallButton } from './edgeChromium'
import { EdgePreChromiumInstallButton } from './edge-pre-chromium'
import { ExtensionInstallDisabledButton } from './browser-specific'

export interface BrowserInstallButtonProps extends Omit<ExtensionInstallButtonProps, 'onClick' | 'installUrl'> {
  onClick?: () => void
}

export const BrowserInstallButton: React.FC<BrowserInstallButtonProps> = (props) => {
  const preferredInstall = useFirstEligibleInstall(extensionInstallTypes)

  switch (preferredInstall) {
    case InstallType.Firefox:
      return <FirefoxInstallButton {...props} />
    case InstallType.Safari:
      return <SafariInstallButton {...props} />
    case InstallType.EdgeChromium:
      return <EdgeChromiumInstallButton {...props} />
    case InstallType.EdgePreChromium:
      return <EdgePreChromiumInstallButton {...props} />
    case InstallType.Chrome:
      return <ChromeInstallButton {...props} />
    default:
      return <ExtensionInstallDisabledButton {...props} />
  }
}

export const BrowserInstallLink: React.FC<BrowserInstallButtonProps> = (props) => {
  return <BrowserInstallButton {...props} asLink />
}
